import { addPlayerEnterChatItem, addPlayerLeaveChatItem } from './chatActions';
import { setPlayerServerSettingsFromInbound, thunkSetSelfDataFromInbound } from './selfDataActions';
import { thunkEndTransitionAnimation } from './transitionAnimationActions';
export const CLEAR_LOBBY_SCENE = 'CLEAR_LOBBY_SCENE';
export const LOBBY_BROWSE_FROM_INBOUND = 'LOBBY_BROWSE_FROM_INBOUND';
export const ENTER_LOBBY_PLAYER_FROM_INBOUND = 'ENTER_LOBBY_PLAYER_FROM_INBOUND';
export const LEAVE_LOBBY_PLAYER_FROM_INBOUND = 'LEAVE_LOBBY_PLAYER_FROM_INBOUND';
export const ADD_ROOMS_TO_LOBBY = 'ADD_ROOMS_TO_LOBBY';
export const REMOVE_ROOM_FROM_LOBBY = 'REMOVE_ROOM_FROM_LOBBY';
export const SET_LOBBY_PLAYER_BANK = 'SET_LOBBY_PLAYER_BANK';
export const UPDATE_LOBBY_ROOM_FROM_INBOUND = 'UPDATE_LOBBY_ROOM_FROM_INBOUND';
export const UPDATE_LOBBY_ROOM_VARIABLE_FROM_INBOUND = 'UPDATE_LOBBY_ROOM_VARIABLE_FROM_INBOUND';
export const RENAME_LOBBY_ROOM_FROM_INBOUND = 'RENAME_LOBBY_ROOM_FROM_INBOUND';
export const SHOW_LOBBY_PRIZE_WIN_FROM_INBOUND = 'SHOW_LOBBY_PRIZE_WIN_FROM_INBOUND';
export const HIDE_LOBBY_PRIZE_WIN = 'HIDE_LOBBY_PRIZE_WIN';
export function clearLobbyScene() {
    return {
        type: CLEAR_LOBBY_SCENE
    };
}
function initLobbyFromInbound(inbound) {
    return {
        type: LOBBY_BROWSE_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkLobbyBrowseFromInbound = (inbound) => {
    return function (dispatch) {
        dispatch(setPlayerServerSettingsFromInbound(inbound.inboundPlayerServerSettings));
        dispatch(thunkSetSelfDataFromInbound(inbound.inboundSelfData));
        dispatch(initLobbyFromInbound(inbound));
        dispatch(thunkEndTransitionAnimation());
    };
};
function enterLobbyPlayerFromInbound(inbound) {
    return {
        type: ENTER_LOBBY_PLAYER_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkEnterLobbyPlayerFromInbound = (inbound) => {
    return function (dispatch, getState) {
        const state = getState();
        if (state.lobby.showLobbyTraffic) {
            dispatch(addPlayerEnterChatItem(inbound.enterMessage));
        }
        dispatch(enterLobbyPlayerFromInbound(inbound));
    };
};
function leaveLobbyPlayerFromInbound(inbound) {
    return {
        type: LEAVE_LOBBY_PLAYER_FROM_INBOUND,
        payload: inbound
    };
}
export const thunkLeaveLobbyPlayerFromInbound = (inbound) => {
    return function (dispatch, getState) {
        const state = getState();
        if (state.lobby.showLobbyTraffic) {
            // When a player leaves, it could be that they are logging out, and the provided message contains '%name%' that needs to be replaced.
            // TODO: Improve this hacky stuff.
            const existingInitializedPlayer = state.lobby.lobbyPlayers.find((player) => player.sessionId === inbound.sessionId && player.isClientLoadDone);
            if (existingInitializedPlayer) {
                const leaveMessage = inbound.lobbyLeaveMessageTemplate.split('%name%').join(existingInitializedPlayer.name);
                dispatch(addPlayerLeaveChatItem(leaveMessage));
            }
        }
        dispatch(leaveLobbyPlayerFromInbound(inbound));
    };
};
export function addRoomToLobby(lobbyRoom) {
    return addRoomsToLobby([lobbyRoom]);
}
export function addRoomsToLobby(lobbyRooms) {
    return {
        type: ADD_ROOMS_TO_LOBBY,
        payload: lobbyRooms
    };
}
export function removeRoomFromLobby(roomId) {
    return {
        type: REMOVE_ROOM_FROM_LOBBY,
        payload: roomId
    };
}
export function setLobbyPlayerBank(playerId, numChipsInBank) {
    return {
        type: SET_LOBBY_PLAYER_BANK,
        payload: { playerId, numChipsInBank }
    };
}
export function updateLobbyRoomFromInbound(inbound) {
    return {
        type: UPDATE_LOBBY_ROOM_FROM_INBOUND,
        payload: inbound
    };
}
export function updateLobbyRoomVariableFromInbound(inbound) {
    return {
        type: UPDATE_LOBBY_ROOM_VARIABLE_FROM_INBOUND,
        payload: inbound
    };
}
export function renameLobbyRoomFromInbound(inbound) {
    return {
        type: RENAME_LOBBY_ROOM_FROM_INBOUND,
        payload: inbound
    };
}
export function showLobbyPrizeWinFromInbound(inbound) {
    return { type: SHOW_LOBBY_PRIZE_WIN_FROM_INBOUND, payload: inbound };
}
export function hideLobbyPrizeWin() {
    return { type: HIDE_LOBBY_PRIZE_WIN };
}
